<script>
    import BackgroundMediaMixin from "../../../author/pagesbuilder/mixins/BackgroundMediaMixin";

    export default {
        name: "MediaGalleryElement",
        mixins: [BackgroundMediaMixin],
        data() {
            return {
                givesContextToChildren: true,
                elementType: 'media-gallery',

                // Overridden ColumnsReorderingMixin to add more values
                listItemsClassMap : {
                    "1" : "oneItem-per-row",
                    "2" : "twoItems-per-row",
                    "3" : "threeItems-per-row",
                    "4" : "fourItems-per-row",
                    "5" : "fiveItems-per-row"
                },

                // Config values
                whenClickedOptions: [
                    {label: "Do nothing", value: "nothing"},
                    {label: "Pop up slideshow", value: "show"},
                ],
                mediaPerRowOptions: [
                    {label: "1", value: "1"},
                    {label: "2", value: "2"},
                    {label: "3", value: "3"},
                    {label: "4", value: "4"},
                    {label: "5", value: "5"},
                ],
                screenSizeOptions: [
                    {label: "Small", value: "small"},
                    {label: "Normal", value: "normal"},
                    {label: "Large", value: "large"},
                    {label: "Full", value: "full"},
                ],
            }
        },
        computed: {
            getDefaultDataStructure() {
                return {
                    elementId: this.elementId,
                    elementType: this.elementType,
                    responsiveAlignmentClass: {
                        'desktop': '',
                        'tablet-portrait': '',
                        'tablet-landscape': '',
                        'smartphone-portrait': '',
                        'smartphone-landscape': ''
                    },
                    whenClicked: "nothing",
                    slideShowShowCaptions: false,
                }
            },
            fancyboxId() {
                return "fancybox_" + this.elementId;
            }
        },
        methods: {
            getWhenClicked() {
                return this.myData.whenClicked;
            },
            setWhenClicked(v) {
                this.changeMyData({whenClicked: v});
            },
            getShowCaptions() {
                return this.myData.slideShowShowCaptions;
            },
            setShowCaptions(v) {
                this.changeMyData({slideShowShowCaptions: v});
            },
        },
    }
</script>